import { render } from "./Costs.vue?vue&type=template&id=5ae9752e&scoped=true"
import script from "./Costs.vue?vue&type=script&lang=js"
export * from "./Costs.vue?vue&type=script&lang=js"

import "./Costs.vue?vue&type=style&index=0&id=5ae9752e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae9752e"]])

export default __exports__